import firebaseService from "./firebaseService";
const firebaseApp = firebaseService();

import { toRefs, reactive, watch } from "vue";


const state = reactive({
    userDataCache: {},    
});

const unsubscribeHandles = [];


    async function teardown() {
        for (let unsubscribeHandle of unsubscribeHandles) {
            await unsubscribeHandle();
        }
        //empty it
        unsubscribeHandles.length = 0;
        
    }

    async function getUser(uid) {

        if(!uid){
            return new Promise((resolve) => {resolve(null)});
        }
        if (!state.userDataCache[uid]) {
            const resp = await firebaseApp
                .firestore()
                .collection("users")
                .doc(uid ? uid : null)
                .get();

            if (resp.exists) {
                state.userDataCache[uid] = {
                    ...resp.data(),
                    id: uid
                }
            }
        }
        return state.userDataCache[uid] ? state.userDataCache[uid] : new Promise((resolve) => {resolve(null)});
    }



    export default {
        ...toRefs(state),
        getUser,       

    }

